const requiresRestart = (table) => {
    const restartTables = ['businessRule'];
    return restartTables.includes(table);
}

export {
    requiresRestart
}